/**
 * @generated SignedSource<<ec4d441273248c10ec8188333808503b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type defaultPagesSeoPage$data = {
  readonly headline: string | null | undefined;
  readonly urlAlias: string;
  readonly " $fragmentType": "defaultPagesSeoPage";
};
export type defaultPagesSeoPage$key = {
  readonly " $data"?: defaultPagesSeoPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"defaultPagesSeoPage">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "defaultPagesSeoPage",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "headline",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "urlAlias",
      "storageKey": null
    }
  ],
  "type": "Page",
  "abstractKey": null
};

(node as any).hash = "ad20dbec112477c9e20541f79049bc4c";

export default node;
